import { SVG, SVGProps } from './svg'

export function IconStarOutlined(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4 2.32a.5.5 0 0 1 .47-.32h.26c.2 0 .4.12.47.32l2.48 5.89 6.37.51c.2.01.38.15.44.35l.08.25a.5.5 0 0 1-.14.53L17 14l1.43 6.22c.05.2-.02.4-.19.53l-.22.15c-.08.07-.19.1-.3.1a.48.48 0 0 1-.26-.07L12 17.6l-5.43 3.33a.48.48 0 0 1-.25.07.47.47 0 0 1-.3-.1l-.25-.15a.51.51 0 0 1-.2-.53L7.02 14 2.18 9.86a.5.5 0 0 1-.15-.54l.1-.25c.07-.2.24-.34.45-.35l6.37-.51 2.44-5.89Zm7.25 7.93-4.8-.38L12 5.41l-1.85 4.46-4.8.38L9 13.38l-1.13 4.68L12 15.55l4.1 2.51-1.1-4.68 3.65-3.13Z"
      />
    </SVG>
  )
}
